import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "menu-list"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  class: "menu-text"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["sidebar-container", {
      'is-collapsed': $props.isCollapse
    }]),
    ref: "sidebar",
    style: _normalizeStyle($options.sidebarStyle)
  }, [_createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.menuItems, item => {
    return _openBlock(), _createElementBlock("div", {
      key: item.index,
      class: _normalizeClass(["menu-item", {
        'is-active': $props.activeIndex === item.index
      }]),
      onClick: $event => $options.handleSelect(item.index)
    }, [_createVNode(_component_font_awesome_icon, {
      icon: item.icon,
      class: "menu-icon"
    }, null, 8, ["icon"]), _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t(item.titleKey)), 1)], 10, _hoisted_2);
  }), 128))]), _createElementVNode("div", {
    class: "toggle-button",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.toggleCollapse && $options.toggleCollapse(...args))
  }, [_createVNode(_component_font_awesome_icon, {
    icon: $props.isCollapse ? 'angle-double-right' : 'angle-double-left'
  }, null, 8, ["icon"])])], 6);
}